let loadingCount = 0;
const loadingSubscribers = new Set();
const loadingHistory = new Map();

export const LoadingService = {
  generateId() {
    return Math.random().toString(36).substring(2, 8);
  },
  increment(message, id) {
    const messageWithId = message ? `${message} [${id}]` : id;
    loadingCount++;
    loadingHistory.set(id, {
      message: messageWithId,
      status: 'loading',
      timestamp: Date.now()
    });
    this.notify();
    return id;
  },
  decrement(message, id) {
    const messageWithId = message ? `${message} [${id}]` : id;
    loadingCount = Math.max(0, loadingCount - 1);
    loadingHistory.set(id, {
      message: messageWithId,
      status: 'completed',
      timestamp: Date.now()
    });
    this.notify();
    return id;
  },
  
  subscribe(callback) {
    loadingSubscribers.add(callback);
    return () => {
      loadingSubscribers.delete(callback);
    };
  },
  notify() {
    const history = Array.from(loadingHistory.entries()).map(([id, data]) => ({
      id,
      ...data
    }));
    const isLoading = this.isLoading;
    loadingSubscribers.forEach(cb => cb(isLoading, history));
  },
  get isLoading() {
    return Array.from(loadingHistory.values()).some(task => task.status === 'loading');
  },
  getLoadingHistory() {
    return Array.from(loadingHistory.entries()).map(([id, data]) => ({
      id,
      ...data
    }));
  },
  clearHistory() {
    loadingHistory.clear();
  },
  isAllCompleted() {
    return loadingHistory.size > 0 && Array.from(loadingHistory.values()).every(task => task.status === 'completed');
  }
};